'use client';

import type { ClassAttributes, HTMLAttributes } from 'react';
import { useIntl } from 'react-intl';
import type { Availability } from '@packages/gql/generated/shopping/graphql';
import { availabilityInfoMessages } from './messages';
import { AvailabilityInfoIndicator } from '../AvailabilityInfoIndicator/AvailabilityInfoIndicator';

const contentWrapperDefaultClasses: HTMLAttributes<HTMLDivElement>['className'] =
  'flex flex-row flex-nowrap gap-1';

export type AvailabilityInfoProps = ClassAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    availabilityMessage: Availability['message'];
    availabilityState: Availability['state'];
  };
/**
 * AvailabilityInfo component displays product availability
 * */
export const AvailabilityInfo = ({
  availabilityMessage,
  availabilityState,
  ...props
}: AvailabilityInfoProps) => {
  const { formatMessage } = useIntl();

  let message: string;
  let bold = false;
  if (availabilityState === 'UNSELECTED') {
    message = formatMessage(availabilityInfoMessages.deliveryMessageUnselected);
  } else if (availabilityMessage.length === 0) {
    message = formatMessage(availabilityInfoMessages.deliveryMessageFallback);
  } else {
    message = availabilityMessage;
    bold = true;
  }
  const defaultContent = (
    <>
      <AvailabilityInfoIndicator type={availabilityState} />
      <div className={`text-size-body-sm ${bold && 'font-bold'}`}>{message}</div>
    </>
  );

  if (availabilityState !== 'UNSELECTED') {
    return (
      <div {...props} className="flex flex-col flex-nowrap gap-0.5">
        <div className={`${contentWrapperDefaultClasses} items-center`}>{defaultContent}</div>
      </div>
    );
  }

  return (
    <div {...props} className={`${contentWrapperDefaultClasses} items-center`}>
      {defaultContent}
    </div>
  );
};
